import PropTypes from 'prop-types';
import React from 'react';
import { Field, FormSection } from 'redux-form';

import Grid from '@glass/web/components/base/Unstable_Grid2';
import { LOCATION_FIELD_V2, PUBLIC_FIELD_V2 } from '@glass/web/modules/resumes/fieldKeys';

import EmailField from '@glass/shared/components/Form/EmailField';
import PhoneField from '@glass/shared/components/Form/PhoneField';
import SwitchWithLabelRf from '@glass/shared/components/Form/SwitchWithLabelRf';
import {
  CityField,
  CountryField,
  FirstNameField,
  LastNameField,
  StateField,
  StreetField,
  ZipCodeField,
} from '@glass/shared/components/ResumeBuilder/fields/FormTextFields';
import useResumeWords from '@glass/shared/modules/content/staticVariations/resumeWords/useResumeWords';
import contactPath from '@glass/shared/modules/resumes/paths/contactPath';

function ContactFields({ isMinimal, autoFocus }) {
  const resumeWords = useResumeWords();
  return (
    <>
      <FormSection name={contactPath}>
        <Grid container spacing={1}>
          <Grid sm={6} xs={12}>
            <FirstNameField autoFocus={autoFocus} />
          </Grid>
          <Grid sm={6} xs={12}>
            <LastNameField />
          </Grid>
          <Grid xs={12}>
            <FormSection name={LOCATION_FIELD_V2}>
              <Grid container spacing={1}>
                {isMinimal ? null : (
                  <Grid md={8} xs={12}>
                    <StreetField />
                  </Grid>
                )}
                {isMinimal ? null : (
                  <Grid md={4} xs={6}>
                    <ZipCodeField />
                  </Grid>
                )}
                <Grid md={4} xs={6}>
                  <CityField />
                </Grid>
                <Grid md={4} xs={6}>
                  <StateField />
                </Grid>
                <Grid md={4} xs={6}>
                  <CountryField />
                </Grid>
              </Grid>
            </FormSection>
          </Grid>
          {isMinimal ? null : (
            <Grid sm={6} xs={12}>
              <PhoneField />
            </Grid>
          )}
          <Grid sm={isMinimal ? 12 : 6} xs={12}>
            <EmailField />
          </Grid>
        </Grid>
      </FormSection>
      <Grid container spacing={1}>
        <Grid xs={12}>
          <Field
            color="primary"
            component={SwitchWithLabelRf}
            label={`Share ${resumeWords.abbreviated} with relevant hiring managers`}
            name={PUBLIC_FIELD_V2}
          />
        </Grid>
      </Grid>
    </>
  );
}

ContactFields.propTypes = {
  autoFocus: PropTypes.bool,
  isMinimal: PropTypes.bool,
};

export default React.memo(ContactFields);
